/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_No_TeamInputs */

const th_player_no_team = /** @type {(inputs: Player_No_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ขณะนี้ยังไม่ได้สังกัดทีมใด`)
};

const en_player_no_team = /** @type {(inputs: Player_No_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not on a squad at the moment.`)
};

const ja_player_no_team = /** @type {(inputs: Player_No_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在どのチームにも所属していません。`)
};

const zh_player_no_team = /** @type {(inputs: Player_No_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目前不在任何阵容中。`)
};

const es_player_no_team = /** @type {(inputs: Player_No_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahora mismo no está en ninguna plantilla.`)
};

const pt_player_no_team = /** @type {(inputs: Player_No_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem elenco no momento.`)
};

const id_player_no_team = /** @type {(inputs: Player_No_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saat ini tidak di skuad mana pun.`)
};

const fr_player_no_team = /** @type {(inputs: Player_No_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sans effectif pour le moment.`)
};

const tl_player_no_team = /** @type {(inputs: Player_No_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kasalukuyang wala sa anumang squad.`)
};

const vi_player_no_team = /** @type {(inputs: Player_No_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiện không thuộc đội hình nào.`)
};

const ko_player_no_team = /** @type {(inputs: Player_No_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`현재 소속 선수단이 없습니다.`)
};

const de_player_no_team = /** @type {(inputs: Player_No_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurzeit in keinem Kader.`)
};

const ru_player_no_team = /** @type {(inputs: Player_No_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сейчас не входит ни в один состав.`)
};

const tr_player_no_team = /** @type {(inputs: Player_No_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şu anda hiçbir kadroda değil.`)
};

const it_player_no_team = /** @type {(inputs: Player_No_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attualmente in nessuna rosa.`)
};

const pl_player_no_team = /** @type {(inputs: Player_No_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obecnie w żadnym składzie.`)
};

const uk_player_no_team = /** @type {(inputs: Player_No_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Наразі не входить до жодного складу.`)
};

const hi_player_no_team = /** @type {(inputs: Player_No_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस समय किसी टीम में नहीं।`)
};

const ar_player_no_team = /** @type {(inputs: Player_No_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ليس في أي تشكيلة حاليًا.`)
};

const ms_player_no_team = /** @type {(inputs: Player_No_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kini tiada dalam mana-mana skuad.`)
};

const bn_player_no_team = /** @type {(inputs: Player_No_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এখন কোনও দলে নেই।`)
};

const zh_tw2_player_no_team = /** @type {(inputs: Player_No_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目前不在任何名單中。`)
};

const zh_hk2_player_no_team = /** @type {(inputs: Player_No_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目前不在任何名單中。`)
};

const ur_player_no_team = /** @type {(inputs: Player_No_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اس وقت کسی اسکواڈ میں نہیں۔`)
};

const fa_player_no_team = /** @type {(inputs: Player_No_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هم‌اکنون در هیچ فهرست تیمی نیست.`)
};

const sw_player_no_team = /** @type {(inputs: Player_No_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kwa sasa hayupo kwenye kikosi chochote.`)
};

const nl_player_no_team = /** @type {(inputs: Player_No_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zit op dit moment in geen enkele selectie.`)
};

/**
* | output |
* | --- |
* | "Not on a squad at the moment." |
*
* @param {Player_No_TeamInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const player_no_team = /** @type {((inputs?: Player_No_TeamInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_No_TeamInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_player_no_team(inputs)
	if (locale === "ja") return ja_player_no_team(inputs)
	if (locale === "zh") return zh_player_no_team(inputs)
	if (locale === "es") return es_player_no_team(inputs)
	if (locale === "pt") return pt_player_no_team(inputs)
	if (locale === "id") return id_player_no_team(inputs)
	if (locale === "fr") return fr_player_no_team(inputs)
	if (locale === "tl") return tl_player_no_team(inputs)
	if (locale === "vi") return vi_player_no_team(inputs)
	if (locale === "ko") return ko_player_no_team(inputs)
	if (locale === "de") return de_player_no_team(inputs)
	if (locale === "ru") return ru_player_no_team(inputs)
	if (locale === "tr") return tr_player_no_team(inputs)
	if (locale === "it") return it_player_no_team(inputs)
	if (locale === "pl") return pl_player_no_team(inputs)
	if (locale === "uk") return uk_player_no_team(inputs)
	if (locale === "hi") return hi_player_no_team(inputs)
	if (locale === "ar") return ar_player_no_team(inputs)
	if (locale === "ms") return ms_player_no_team(inputs)
	if (locale === "bn") return bn_player_no_team(inputs)
	if (locale === "zh-TW") return zh_tw2_player_no_team(inputs)
	if (locale === "zh-HK") return zh_hk2_player_no_team(inputs)
	if (locale === "ur") return ur_player_no_team(inputs)
	if (locale === "fa") return fa_player_no_team(inputs)
	if (locale === "sw") return sw_player_no_team(inputs)
	if (locale === "nl") return nl_player_no_team(inputs)
	return en_player_no_team(inputs)
});